"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AsyncStorage = _interopRequireDefault(require("./AsyncStorage"));
var _defaults = require("./defaults");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Copyright (c) React Native Community.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
class AsyncStorageFactory {
  constructor() {
    throw new Error("[AsyncStorage] AsyncStorageFactory must not be instantiated.\nInstead, use its 'create' method to create AsyncStorage instance.");
  }
  static create(storage, opts) {
    return new _AsyncStorage.default(storage, opts || _defaults.factoryOptions);
  }
}
var _default = AsyncStorageFactory;
exports.default = _default;